var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    _vm._b(
      {
        attrs: {
          visible: _vm.visible,
          title: _vm.title,
          fullscreen: _vm.fullscreen,
          "show-close": _vm.showHeaderClose,
          closeOnClickModal: _vm.closeOnClickModal,
          width: _vm.width,
          top: "5vh",
          "z-index": _vm.zIndex,
          "append-to-body": "",
        },
        on: {
          "update:visible": function ($event) {
            _vm.visible = $event
          },
          close: _vm.onClose,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function (ref) {
                var close = ref.close
                var titleId = ref.titleId
                var titleClass = ref.titleClass
                return [
                  _c(
                    "div",
                    {
                      staticClass: "my-header",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("div", { staticClass: "dy-dialog-title" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("full-screen", {
                            staticStyle: {
                              width: "1em",
                              height: "1em",
                              "margin-right": "8px",
                              cursor: "pointer",
                            },
                            attrs: { color: "#909399" },
                            on: {
                              click: function ($event) {
                                _vm.fullscreen = !_vm.fullscreen
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("close", {
                            staticStyle: {
                              width: "1em",
                              height: "1em",
                              "margin-right": "8px",
                              cursor: "pointer",
                            },
                            attrs: { color: "#909399" },
                            on: { click: _vm.onClose },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
            },
            _vm.showFooter
              ? {
                  key: "footer",
                  fn: function () {
                    return [
                      _vm._t("footer", function () {
                        return [
                          _vm.showConfirm
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.loading,
                                      expression: "loading",
                                    },
                                  ],
                                  attrs: {
                                    disabled: _vm.loading,
                                    type: "primary",
                                    icon: "el-icon-check",
                                  },
                                  on: { click: _vm.onConfirm },
                                },
                                [_vm._v(_vm._s(_vm.confirmTitle) + "\n      ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-close" },
                              on: { click: _vm.onClose },
                            },
                            [_vm._v("取 消")]
                          ),
                        ]
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      },
      "el-dialog",
      _vm.$attrs,
      false
    ),
    [_vm._v(" "), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }